import { AbsherVerificationAction } from "../actions/AbsherVerificationAction"
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initAbsherVerify = {
    requestBody: {
        sectionId: "AbsherVerification&TCCRegistration",
        steps: [
            {
                sequence: "0",
                stepId: "AbsherVerification&TCCRegistration",
                offerContainerId: "",
                fields: [
                    {
                        name: "IAMToken",
                        value: ""
                    },
                    {
                        name: "SIM Details",
                        value: ""
                    },
                    {
                        name: "TCCRegistration Response",
                        value: ""
                    }
                ],
                options: [
                    {
                        name: "Nafath Option",
                        value: ""
                    }
                ]
            }
        ]
    },
    getSimDetailsData: {},
    tccRegisterData: {},
    byPassVerificationData: {},
};

const AbsherVerificationReducer = (state: any = initAbsherVerify, action: any) => {
    const { type } = action;
    const { payload } = action;
    var AbsherData = { ...state.requestBody.steps }
    switch (type) {

        case AbsherVerificationAction.GET_SIM_DETAILS_SUCCESS:
            return { ...state, getSimDetailsData: payload }

        case AbsherVerificationAction.TCC_REGISTRATION_SUCCESS:
            return { ...state, tccRegisterData: payload }

        case AbsherVerificationAction.BYPASS_VERIFICATION_SUCCESS:
            return { ...state, byPassVerificationData: payload }

        case AbsherVerificationAction.ABSHER_VERIFICATION_COMPLETE:
            AbsherData[0].offerContainerId = payload.ocId;
            AbsherData[0].fields[0].value = payload.IAMToken;
            AbsherData[0].fields[1].value = payload.simDetails ? JSON.stringify(payload.simDetails) : "";
            AbsherData[0].fields[2].value = JSON.stringify(payload.tccRegisterResponse);
            AbsherData[0].options[0].value = payload.nafathOption;
            // remove sim details for cold_SSA as sim details is empty
            if (!AbsherData[0].fields[1].value){
                AbsherData[0].fields.splice(1,1);
            }
            return state;

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'AbsherVerification&TCCRegistration')
            });
            if (section.length > 0) {
                AbsherData[0].offerContainerId = section[0].steps[0].offerContainerId;
                AbsherData[0].options[0].value = section[0].steps[0].options[0].value;
                for (let i = 0; i < AbsherData[0].fields.length; i++) {
                    const AbsherField = section[0].steps[0].fields.filter((field: any) => { return (field.name === AbsherData[0].fields[i].name) })[0];
                    AbsherData[0].fields[i].value = AbsherField ? AbsherField.value : "";
                }
            }
            return state;

        default:
            return state;
    }
};

export default AbsherVerificationReducer;
